export function hightlightAutocompleteSearchPart(searchPart, results) {
    return results.map((resultItem) => {
        const re = new RegExp(`(${searchPart})`, "gi");
        const template = "<span class='autocomplete__item__highlight text-gray-500'>$1</span>";
        const label = resultItem.name.replace(re, template);
        return { ...resultItem, label };
    });
}
